import styled from "styled-components"

export const StyledFooterMedia = styled.div`
  li {
    transition: transform 250ms ease;
    &:hover {
      transform: scale(1.05);
    }
  }
`
